import { atom } from "jotai";
import type { ICompanyIssuerFieldsFragment } from "lib/graphql/fragments/__generated__/CompanyIssuerFields.generated";
import { IFinancialsStatementType } from "types/graphqlTypes";

export type CompanyIssuerNode = Omit<ICompanyIssuerFieldsFragment, "__typename">;
export type ComplexNavigationHistoryItemNode = {
  company: CompanyIssuerNode;
  financialsTemplateId?: string | null;
  timeStamp?: number;
};

export const INTERIM_ATOM = atom<string | null>(null);
export const STATEMENT_TYPE_ATOM = atom<IFinancialsStatementType>(IFinancialsStatementType.Annual);
export const SELECTED_FINANCIALS_TEMPLATE_ATOM = atom<string | null>(null);
export const COMPANY_ISSUER_NAVIGATION_HISTORY_ATOM = atom<ComplexNavigationHistoryItemNode[]>([]);
